<template>
  <main class="company consult page-main">
    <section class="page-heading-wrap">
      <h3 class="page-heading">{{ $t('consult.head') }}</h3>
      <div class="page-heading-desc">
        <html-view :value="$t('consult.copy')" tag="p" />
      </div>
    </section>

    <section class="company-consult">
      <div class="company-box">
        <div class="company-box-content">
          <table class="table">
            <colgroup>
              <col style="width:30%">
              <col>
            </colgroup>
            <tbody>
              <tr>
                <th>{{ $t('consult.table.th1') }}</th>
                <td><router-link :to="{name: 'ConsultForm'}" class="btn-link">{{ $t('consult.table.td1') }}<icon-blank /></router-link></td>
              </tr>
              <tr>
                <th>{{ $t('consult.table.th2') }}</th>
                <td><a href="mailto:ethics@woowahan.com">ethics@woowahan.com</a></td>
              </tr>
              <tr>
                <th>{{ $t('consult.table.th3') }}</th>
                <td><html-view :value="$t('consult.table.td3')" tag="address" /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="company-box">
        <div class="company-box-title">{{ $t('consult.purpose.title') }}</div>
        <div class="company-box-content">
          <div>{{ $t('consult.purpose.content') }}</div>
        </div>
      </div>
      <div class="company-box">
        <div class="company-box-title">{{ $t('consult.target.title') }}</div>
        <div class="company-box-content">
          <ul>
            <li>{{ $t('consult.target.list.item1') }}</li>
            <li>{{ $t('consult.target.list.item2') }}</li>
            <li>{{ $t('consult.target.list.item3') }}</li>
            <li>{{ $t('consult.target.list.item4') }}</li>
          </ul>
        </div>
      </div>
      <div class="company-box program">
        <div class="company-box-title">{{ $t('consult.program1.title') }}</div>
        <div class="company-box-content">
          <div class="program-box">
            <p class="program-box-title">{{ $t('consult.program1.title') }}</p>
            <div>
              <ul>
                <li>{{ $t('consult.program1.list.item1') }}</li>
                <li>{{ $t('consult.program1.list.item2') }}</li>
              </ul>
            </div>
          </div>
          <div class="program-box">
            <p class="program-box-title">{{ $t('consult.program2.title') }}</p>
            <div>
              <ul>
                <li>{{ $t('consult.program2.list.item1') }}</li>
                <li>{{ $t('consult.program2.list.item2') }}</li>
              </ul>
            </div>
          </div>
          <div class="program-box">
            <p class="program-box-title">{{ $t('consult.program3.title') }}</p>
            <div>
              <ul>
                <li>{{ $t('consult.program3.list.item1') }}</li>
                <li>{{ $t('consult.program3.list.item2') }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
import defendPath from '@/mixins/defendPath'

export default {
  components: {
    iconBlank: () => import('@/static/svg/blank.svg'),
  },
  mixins: [defendPath],
}
</script>
